import * as Sentry from "@sentry/react";
import { dropWhileReloadingForStaleChunk } from "./staleChunkReload";

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;

if (SENTRY_DSN) {
  // Phase 1: errors + breadcrumbs only.
  // Sentry's default integrations include breadcrumbsIntegration (clicks /
  // navigations / fetches / console logs) and globalHandlersIntegration
  // (uncaught errors / unhandled rejections), both auto-attached to every
  // error event. We deliberately omit browserTracingIntegration and
  // replayIntegration — for a Phase 1 demo we don't need perf monitoring or
  // session replay, and shipping 100% of transactions saturated Sentry's
  // ingest rate limit on the first day. Re-enable when there's a real
  // observability need.
  Sentry.init({
    dsn: SENTRY_DSN,
    integrations: [],
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    environment: import.meta.env.MODE,
    sendDefaultPii: false,
    // A stale tab reloading onto a new deploy (SC-3705) is not an error.
    beforeSend: dropWhileReloadingForStaleChunk,
  });
}

export default Sentry;
